export const handleOpen2 = (e, setOpen2) => {
    e.preventDefault();
    setOpen2(true);
  };